import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('Error boundary caught:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="text-center max-w-lg">
            <p className="text-[#004f4f] font-bold text-lg mb-4 tracking-wide uppercase" aria-hidden="true">
              Błąd aplikacji
            </p>
            <h1 className="text-4xl font-bold text-slate-900 mb-6">
              Coś poszło nie tak
            </h1>
            <p className="text-slate-600 text-lg leading-relaxed mb-10">
              Przepraszamy za niedogodności. Spróbuj odświeżyć stronę lub wróć na stronę główną.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="inline-flex items-center justify-center gap-2 bg-[#004f4f] text-white px-6 py-3 rounded-full hover:bg-[#003d3d] focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold text-base"
              >
                Odśwież stronę
              </button>
              <a
                href="/"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#004f4f] text-[#004f4f] px-6 py-3 rounded-full hover:bg-[#004f4f] hover:text-white focus:outline-none focus:ring-4 focus:ring-[#004f4f] focus:ring-offset-4 transition-colors font-bold text-base"
              >
                Strona główna
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
